import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import logo from './Images/logo.png';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import Tooltip from '@mui/material/Tooltip';


export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
    }

   

  render () {
    return (
      <header>
            <Navbar
                className="electron-drag navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
                light
            >
                <Container
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "20px",
                    }}
                >
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <NavbarBrand className=" electron-no-drag " tag={Link} to="/"><img src={logo} width="100vw" /></NavbarBrand>
                        <h6 style={{ marginBottom: "0", color: "#5e5e5e"}} >Command Center</h6>
                    </div>
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center", // 🔹 wyśrodkowuje ul wewnątrz
                        }}
                    >
                    <Collapse className="d-sm-flex justify-content-center" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav text-center d-flex flex-row gap-1" style={{
                                fontSize: "14px",
                            }}>
                <NavItem>
                                    <NavLink tag={Link} className="electron-no-drag" to="/">Home</NavLink>
                            </NavItem>
                            <NavItem>
                                    <NavLink tag={Link} className="electron-no-drag" to="/chat">Chat</NavLink>
                            </NavItem>
                <NavItem>
                                    <NavLink tag={Link} className="electron-no-drag" to="/jobs">Jobs</NavLink>
                </NavItem>
                <NavItem>
                                    <NavLink tag={Link} className="electron-no-drag" to="/agents">Agents</NavLink>
                            </NavItem>
                            <NavItem>
                                    <NavLink tag={Link} className="electron-no-drag" to="/resources">Resources</NavLink>
                        </NavItem>
                            {/*<NavItem>*/}
                            {/*    <NavLink tag={Link} className="" to="/data">Data</NavLink>*/}
                            {/*</NavItem>*/}
                            <NavItem>
                                    <NavLink tag={Link} className="electron-no-drag" to="/management">Management</NavLink>
                            </NavItem>
                           
              </ul>
                        </Collapse>
                    </div>
                    <div style={{
                        width: "263px",
                        justifyContent: "end",
                        display:"flex",
                    }} >
                    <Tooltip describeChild title="Log out">
                            <Button onClick={this.props.logOut} toolTip="test" color="error" className="electron-no-drag" style={{color:"#863ad8" }}><LogoutIcon></LogoutIcon></Button>
                        </Tooltip>
                    </div>
          </Container>
        </Navbar>
      </header>
    );
  }
}
